import * as types from './actionTypes';

export const request = data => ({ type: types.REQUEST, data });
export const succeeded = result => ({ type: types.SUCCEEDED, result });
export const deleteThis = key => ({ type: types.DELETETHIS, key });
export const internalUpdate = (key,value) => ({ type: types.INTERNAL_UPDATE, key, value });